var isArray = Array.isArray;

var arrayMerge = function arrayMerge() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var arg1 = args.shift();

  if (!isArray(arg1)) {
    arg1 = [arg1];
  }

  args.forEach(function (a) {
    if (null === a || 'undefined' === typeof a) {
      return;
    }

    if (isArray(a)) {
      arg1 = arg1.concat(a);
    } else {
      arg1.push(a);
    }
  });
  return arg1;
};

export default arrayMerge;